/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback, useRef } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import MainHeader from "../../../../Shared/components/Header";
import { Row, Col, Image, Space } from "antd";
import { TextField, Autocomplete } from "@mui/material";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import { ListTable } from "./ListTable";
import Down from "../../../../Shared/components/Icons/Down";
import crudActions from "../../../../CRUD/redux/actions";
import usePrevious from "../../../../Shared/components/Previous";
import addressActions from "../../../../Admin/Address/redux/actions";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import { checkViewPermission, checkComponentPermission } from "../../../../../helpers/utilities";
import { ImportExport } from '../../../../Shared/components/ImportExport';
import actions from "../../redux/actions";

const GlobalAddress = (props) => {
    const { addressDetails, loader } = useSelector(state => state.homeReducer);
    const { cityDetails, pincodeDetails, stateDetails, areaDetails } = useSelector(state => state.addressReducer);
    const { getList, getData } = useSelector(state => state.crudReducer);
    const [skip, setSkip] = useState(0);
    const searchInput = useRef(null);

    const dispatch = useDispatch();
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");

    const limit = 25;
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const [cityData, setCityData] = useState('');
    const [pincodeData, setPincodeData] = useState('');
    const [areaData, setAreaData] = useState('');
    const [iconAnimation, setIconAnimation] = useState(false);
    const [search, setSearch] = useState('');
    const timeoutRef = useRef(null);
    const prevSearch = usePrevious(search);
    const [importVisible, setImportVisible] = useState(false);
    const [filterData, setfilterData] = useState({});

    const { roleManagement } = useSelector(state => state.authReducer);
    const { history } = props;

    useEffect(() => {
        if (roleManagement !== '') {
            if (checkViewPermission('Global Address Book', history, 'Younote Admin')) {
                loadTasks();
            }
        }
        return () => {
            dispatch({
                type: addressActions.CLEAR_ADDRESS_DETAILS_START,
            });
        };
    }, [roleManagement]);

    const customObject = (details, id) => {
        let a = details && details.filter((el) => { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    useEffect(() => {
        if ((prevSearch !== undefined && search && search?.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(sortBy, sortOrder, 0, filterData);
            } else {
                timeoutRef.current = setTimeout(() => {
                    dispatchFilter(sortBy, sortOrder, 0, filterData);
                }, 500);
            }
        }
    }, [search]);

    const prevGetData = usePrevious(getData); useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData?.length > 0) {
                    setLoadMore(true);
                    if (getData?.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);


    const handleChange = (e) => {
        if (e.target.value === '') {
            handleChangeFilter('', e.target.name)
        }
    }

    const handleChangeFilter = (value, name) => {
        if (value !== '') {
            if (name === 'stateId') {
                setfilterData({
                    [name]: value,
                });
                dispatchFilter(sortBy, sortOrder, 0, {
                    [name]: value
                });
                changeStateApi(value);
            } else if (name === 'cityId') {
                let city = cityDetails && cityDetails.length > 0 ? cityDetails.filter((el) => { return el.id === value }) : [];
                if (city && city.length > 0) {
                    setfilterData({
                        [name]: value,
                        'stateId': city[0]?.stateId
                    });
                    dispatchFilter(sortBy, sortOrder, 0, {
                        [name]: value,
                        'stateId': city[0]?.stateId
                    });
                }
                dispatch({
                    type: addressActions.PINCODE_DETAILS_START, url: 'pincode', filter: {
                        where: { ["and"]: [{ cityId: value }] }
                    }
                });
            } else if (name === 'pincodeId') {
                let pincode = pincodeDetails && pincodeDetails.length > 0 ? pincodeDetails.filter((el) => { return el.id === value }) : [];
                if (pincode && pincode.length > 0) {
                    setfilterData({
                        [name]: value,
                        'stateId': pincode[0]?.stateId,
                        'cityId': pincode[0]?.cityId
                    });
                    dispatchFilter(sortBy, sortOrder, 0, {
                        [name]: value,
                        'stateId': pincode[0]?.stateId,
                        'cityId': pincode[0]?.cityId
                    });
                }
                dispatch({
                    type: addressActions.AREA_DETAILS_START, url: 'areas', filter: {
                        where: { ["and"]: [{ pincodeId: value }] }
                    }
                });
            } else {
                setfilterData({
                    ...filterData,
                    [name]: value,
                });
                dispatchFilter(sortBy, sortOrder, 0, {
                    ...filterData,
                    [name]: value,
                });
            }
        } else {
            if (name === 'stateId') {
                setCityData([]);
                setPincodeData([]);
                setfilterData({
                    ...filterData,
                    [name]: value,
                    'cityId': '',
                    'pincodeId': '',
                    'areaId': ''
                });
                dispatchFilter(sortBy, sortOrder, 0, {
                    ...filterData,
                    [name]: value,
                    'cityId': '',
                    'pincodeId': '',
                    'areaId': ''
                });
            } else if (name === 'cityId') {
                if (filterData?.stateId && filterData?.stateId !== '') {
                    dispatch({
                        type: addressActions.PINCODE_DETAILS_START, url: 'pincode', filter: {
                            where: { ["and"]: [{ stateId: filterData?.stateId }] },
                            order: 'id desc'
                        }
                    });
                } else {
                    setPincodeData([]);
                }
                setfilterData({
                    ...filterData,
                    [name]: value,
                    'pincodeId': '',
                    'areaId': ''
                });
                dispatchFilter(sortBy, sortOrder, 0, {
                    ...filterData,
                    [name]: value,
                    'pincodeId': '',
                    'areaId': ''
                });
            } else if (name === 'pincodeId') {
                setAreaData([]);
                setfilterData({
                    ...filterData,
                    [name]: value,
                    'areaId': ''
                });
                dispatchFilter(sortBy, sortOrder, 0, {
                    ...filterData,
                    [name]: value,
                    'areaId': ''
                });
            } else {
                setfilterData({
                    ...filterData,
                    [name]: value,
                });
                dispatchFilter(sortBy, sortOrder, 0, {
                    ...filterData,
                    [name]: value,
                });
            }
        }
    }

    const changeStateApi = (value) => {
        dispatch({
            type: addressActions.PINCODE_DETAILS_START, url: 'pincode', filter: {
                where: { ["and"]: [{ stateId: value }] },
                order: 'id desc'
            }
        });
        dispatch({
            type: addressActions.CITY_DETAILS_START, url: 'city', filter: {
                where: { ["and"]: [{ stateId: value }] },
                order: 'id desc'
            }
        });
    }

    const loadTasks = useCallback(() => {
        dispatch({
            type: addressActions.STATE_DETAILS_START, url: 'state', filter: {
                order: 'id desc'
            }
        });
        dispatch({
            type: addressActions.COUNTRY_DETAILS_START, url: 'country', filter: {
                order: 'id desc'
            }
        });
        dispatchFilter(sortBy, sortOrder, 0, filterData);
    });

    useEffect(() => {
        setPincodeData(pincodeDetails);
    }, [pincodeDetails]);

    useEffect(() => {
        setCityData(cityDetails);
    }, [cityDetails]);

    useEffect(() => {
        setAreaData(areaDetails);
    }, [areaDetails]);

    const dispatchFilter = (sortBy, sortOrder, skip = 0, filterData) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }

        let filter = { ["and"]: [] };
        let or = { ["or"]: [] };

        if (search !== '') {
            or['or'].push({ contactName: { like: '%' + search + '%' } });
            or['or'].push({ businessName: { like: '%' + search + '%' } });
            or['or'].push({ businessId: { like: '%' + search + '%' } });
            or['or'].push({ id: { like: '%' + search + '%' } });
            or['or'].push({ mobile: { like: '%' + search + '%' } });
            or['or'].push({ email: { like: '%' + search + '%' } });
            or['or'].push({ address1: { like: '%' + search + '%' } });
        }

        // if (addressId !== '') {
        //     filter['or'].push({ [`${address}Id`]: addressId });
        // }

        if (filterData) {
            if (filterData?.cityId && filterData?.cityId !== '') {
                filter['and'].push({ cityId: filterData?.cityId });
            }
            if (filterData?.stateId && filterData?.stateId !== '') {
                filter['and'].push({ stateId: filterData?.stateId });
            }
            if (filterData?.pincodeId && filterData?.pincodeId !== '') {
                filter['and'].push({ pincodeId: filterData?.pincodeId });
            }
            if (filterData?.areaId && filterData?.areaId !== '') {
                filter['and'].push({ areaId: filterData?.areaId });
            }
        }


        filter['and'].push(or);
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'addressBook',
            skip: skip,
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip,
            }
        });
    }

    const onSelected = (data) => {
    }

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(sortBy, sortOrder, 0, filterData);
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(sortBy, sortOrder, s, filterData);
    }

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {
        let filter = { ["and"]: [] };
        let or = { ["or"]: [] };

        if (search !== '') {
            or['or'].push({ contactName: { like: '%' + search + '%' } });
            or['or'].push({ businessName: { like: '%' + search + '%' } });
            or['or'].push({ businessId: { like: '%' + search + '%' } });
            or['or'].push({ id: { like: '%' + search + '%' } });
            or['or'].push({ mobile: { like: '%' + search + '%' } });
            or['or'].push({ email: { like: '%' + search + '%' } });
            or['or'].push({ address1: { like: '%' + search + '%' } });
        }

        // if (addressId !== '') {
        //     filter['or'].push({ [`${address}Id`]: addressId });
        // }

        if (filterData) {
            if (filterData?.cityId && filterData?.cityId !== '') {
                filter['and'].push({ cityId: filterData?.cityId });
            }
            if (filterData?.stateId && filterData?.stateId !== '') {
                filter['and'].push({ stateId: filterData?.stateId });
            }
            if (filterData?.pincodeId && filterData?.pincodeId !== '') {
                filter['and'].push({ pincodeId: filterData?.pincodeId });
            }
            if (filterData?.areaId && filterData?.areaId !== '') {
                filter['and'].push({ areaId: filterData?.areaId });
            }
        }


        filter['and'].push(or);
        dispatch({
            type: actions.ADDRESS_DETAILS_START,
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            url: 'addressBook',
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
            }
        });
    }

    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader {...props} img={SettingsImg} title={'Admin'} links={[{ 'label': 'Younote Admin', 'link': '/admin' }, { 'label': 'Global Address Book', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Global Address Book'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('Global Address Book', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search'
                                                type='search'
                                                className={classes.comInput}
                                                onChange={(e) => setSearch(e.target.value)}
                                                variant={'standard'}
                                                fullWidth
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image src={SearchIcon} preview={false} />
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={clsx(classes.textAlignRight, classes.removeUnderline, classes.vertiCalScrollOverFlowParent)}>
                                    <div className={clsx(classes.vertiCalScrollOverFlow, classes.marginLeft10)}>
                                        <Space size={[20, 20]} direction="horizontal" align="center">
                                            {
                                                roleManagement !== '' && checkComponentPermission('Global Address Book', 'Action', 'Radio Selection') &&
                                                <>
                                                    <Autocomplete
                                                        className={clsx(classes.customAutocomplete, classes.customAutocompleteBorder, classes.width150)}
                                                        popupIcon={<Down />}
                                                        fullWidth
                                                        forcePopupIcon={"auto"}
                                                        clearOnEscape
                                                        onClose={() => {
                                                            searchInput?.current?.blur();
                                                        }}
                                                        disableClearable
                                                        getOptionLabel={(option) => option.name ? option.name : ""}
                                                        options={stateDetails ? stateDetails : []}
                                                        classes={{ paper: classes.dropdownStyle }}
                                                        value={stateDetails && customObject(stateDetails, filterData?.stateId, 'state') ? customObject(stateDetails, filterData?.stateId, 'state') : []}
                                                        onChange={(event, newValue) => {
                                                            if (typeof newValue === 'object' && newValue !== null) {
                                                                handleChangeFilter(newValue.id, 'stateId') // help to set the value
                                                            } else {
                                                                handleChangeFilter('', 'stateId') // help to reset the value
                                                            }
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField autoComplete='one-time-code'
                                                                inputRef={searchInput}
                                                                name={'stateId'}
                                                                onChange={(e) => handleChange(e)}
                                                                {...params}
                                                                label='All State'
                                                                variant="standard"
                                                            />
                                                        )}
                                                    />
                                                    {
                                                        filterData?.stateId && <Autocomplete
                                                            className={clsx(classes.customAutocomplete, classes.customAutocompleteBorder, classes.width150)}
                                                            popupIcon={<Down />}
                                                            fullWidth
                                                            forcePopupIcon={"auto"}
                                                            clearOnEscape
                                                            onClose={() => {
                                                                searchInput?.current?.blur();
                                                            }}
                                                            noOptionsText={'Please Select State'}
                                                            disableClearable
                                                            getOptionLabel={(option) => option.name ? option.name : ""}
                                                            options={cityData ? cityData : []}
                                                            classes={{ paper: classes.dropdownStyle }}
                                                            value={cityData && customObject(cityData, filterData?.cityId, 'city') ? customObject(cityData, filterData?.cityId, 'city') : []}
                                                            onChange={(event, newValue) => {
                                                                if (typeof newValue === 'object' && newValue !== null) {
                                                                    handleChangeFilter(newValue.id, 'cityId') // help to set the value
                                                                } else {
                                                                    handleChangeFilter('', 'cityId') // help to reset the value
                                                                }
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField autoComplete='one-time-code'
                                                                    inputRef={searchInput}
                                                                    onChange={(e) => handleChange(e)}
                                                                    {...params}
                                                                    name={'cityId'}
                                                                    label='All City'
                                                                    variant="standard"
                                                                />
                                                            )}
                                                        />
                                                    }
                                                    {
                                                        filterData?.cityId && <Autocomplete
                                                            className={clsx(classes.customAutocomplete, classes.customAutocompleteBorder, classes.width150)}
                                                            popupIcon={<Down />}
                                                            fullWidth
                                                            forcePopupIcon={"auto"}
                                                            clearOnEscape
                                                            onClose={() => {
                                                                searchInput?.current?.blur();
                                                            }}
                                                            disableClearable
                                                            noOptionsText={'Please Select State/City'}
                                                            getOptionLabel={(option) => option.code ? option.code + " (" + option.id + ")" : ""}
                                                            options={pincodeData ? pincodeData : []}
                                                            classes={{ paper: classes.dropdownStyle }}
                                                            value={pincodeData && customObject(pincodeData, filterData?.pincodeId, 'pincodeId') ? customObject(pincodeData, filterData?.pincodeId, 'pincodeId') : []}
                                                            onChange={(event, newValue) => {
                                                                if (typeof newValue === 'object' && newValue !== null) {
                                                                    handleChangeFilter(newValue.id, 'pincodeId') // help to set the value
                                                                } else {
                                                                    handleChangeFilter('', 'pincodeId') // help to reset the value
                                                                }
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField autoComplete='one-time-code'
                                                                    inputRef={searchInput}
                                                                    onChange={(e) => handleChange(e)}
                                                                    {...params}
                                                                    name={'pincodeId'}
                                                                    label='All Pincode'
                                                                    variant="standard"
                                                                />
                                                            )}
                                                        />
                                                    }
                                                    {
                                                        filterData?.pincodeId && <Autocomplete
                                                            className={clsx(classes.customAutocomplete, classes.customAutocompleteBorder, classes.width150)}
                                                            popupIcon={<Down />}
                                                            fullWidth
                                                            forcePopupIcon={"auto"}
                                                            clearOnEscape
                                                            onClose={() => {
                                                                searchInput?.current?.blur();
                                                            }}
                                                            disableClearable
                                                            noOptionsText={'Please Select Pincode'}
                                                            getOptionLabel={(option) => option.name ? option.name : ""}
                                                            options={areaData ? areaData : []}
                                                            classes={{ paper: classes.dropdownStyle }}
                                                            value={areaData && customObject(areaData, filterData?.areaId, 'areaId') ? customObject(areaData, filterData?.areaId, 'areaId') : []}
                                                            onChange={(event, newValue) => {
                                                                if (typeof newValue === 'object' && newValue !== null) {
                                                                    handleChangeFilter(newValue.id, 'areaId') // help to set the value
                                                                } else {
                                                                    handleChangeFilter('', 'areaId') // help to reset the value
                                                                }
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField autoComplete='one-time-code'
                                                                    inputRef={searchInput}
                                                                    onChange={(e) => handleChange(e)}
                                                                    {...params}
                                                                    name={'areaId'}
                                                                    label='All Area'
                                                                    variant="standard"
                                                                />
                                                            )}
                                                        />
                                                    }
                                                </>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Global Address Book', 'Action', 'Merge') &&
                                                <NavLink to="#" className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={ExportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Merge</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Global Address Book', 'Action', 'Export') &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => { loadImportExportData('Address Book'); }}
                                                    className={clsx(classes.customLink)}
                                                >
                                                    <Image
                                                        src={ExportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                                </NavLink>
                                            }
                                        </Space>
                                    </div>
                                </Col>
                            </Row>
                            <ListTable
                                loadTasks={() => loadTasks()}
                                details={getList}
                                loadMore={loadMore}
                                loadMoreContent={loadMoreContent}
                                loadMoreTask={() => loadMoreTask()}
                                onSelected={onSelected}
                                sortOrder={sortOrder} sortBy={sortBy}
                                roleManagement={roleManagement}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)} />
                        </>
                    }
                />
            </div>
            <ImportExport
                handleClose={() => { setImportVisible(false); }}
                visible={importVisible}
                title={'Address Book'}
                type={'import'}
                loader={loader}
                loadImportExportData={(name, type, selected, extension) => loadImportExportData(name, type, selected, extension)}
                details={addressDetails}
                loadTasks={() => { dispatchFilter(sortBy, sortOrder, 0, filterData) }}
            />
        </React.Fragment>
    )
}
export default GlobalAddress